import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LibraryItemForChatReferenceFragment = { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, searchDocuments: Array<{ __typename?: 'SearchDocument', id: string, language: Language }>, myAssignment?: { __typename?: 'Assignment', id: string, currentCourseInstance?: { __typename?: 'CourseInstance', id: number } | null, currentModuleInstance?: { __typename?: 'ModuleInstance', id: string } | null } | null };

export type ChatReferences_AdminLibraryItemsQueryVariables = Types.Exact<{
  input: Types.AdminLibraryInput;
}>;


export type ChatReferences_AdminLibraryItemsQuery = { __typename?: 'Query', AdminLibrary: { __typename?: 'LibraryItems', totalCount: number, objects: Array<{ __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, searchDocuments: Array<{ __typename?: 'SearchDocument', id: string, language: Language }>, myAssignment?: { __typename?: 'Assignment', id: string, currentCourseInstance?: { __typename?: 'CourseInstance', id: number } | null, currentModuleInstance?: { __typename?: 'ModuleInstance', id: string } | null } | null }> } };

export type ChatReferences_TraineeLibraryItemsQueryVariables = Types.Exact<{
  input: Types.TraineeLibraryInput;
}>;


export type ChatReferences_TraineeLibraryItemsQuery = { __typename?: 'Query', TraineeLibrary: { __typename?: 'LibraryItems', totalCount: number, objects: Array<{ __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, searchDocuments: Array<{ __typename?: 'SearchDocument', id: string, language: Language }>, myAssignment?: { __typename?: 'Assignment', id: string, currentCourseInstance?: { __typename?: 'CourseInstance', id: number } | null, currentModuleInstance?: { __typename?: 'ModuleInstance', id: string } | null } | null }> } };

export type ChatReferences_LegacyAdminLibraryBySearchDocsQueryVariables = Types.Exact<{
  input: Types.AdminLibraryInput;
}>;


export type ChatReferences_LegacyAdminLibraryBySearchDocsQuery = { __typename?: 'Query', AdminLibrary: { __typename?: 'LibraryItems', totalCount: number, objects: Array<{ __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, searchDocuments: Array<{ __typename?: 'SearchDocument', id: string, language: Language }>, myAssignment?: { __typename?: 'Assignment', id: string, currentCourseInstance?: { __typename?: 'CourseInstance', id: number } | null, currentModuleInstance?: { __typename?: 'ModuleInstance', id: string } | null } | null }> } };

export type ChatReferences_LegacyAssignmentsBySearchDocsQueryVariables = Types.Exact<{
  input: Types.AssignmentsInput;
}>;


export type ChatReferences_LegacyAssignmentsBySearchDocsQuery = { __typename?: 'Query', Assignments: { __typename?: 'Assignments', totalCount: number, objects: Array<{ __typename?: 'Assignment', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, searchDocuments: Array<{ __typename?: 'SearchDocument', id: string, language: Language }>, myAssignment?: { __typename?: 'Assignment', id: string, currentCourseInstance?: { __typename?: 'CourseInstance', id: number } | null, currentModuleInstance?: { __typename?: 'ModuleInstance', id: string } | null } | null } }> } };

export const LibraryItemForChatReferenceFragmentDoc = gql`
    fragment LibraryItemForChatReference on LibraryItem {
  id
  type
  name {
    uuid
    myTranslation
  }
  coverImage {
    id
    emojiIcon
    background
    imageUrls {
      id
      original
      wide
      medium
      thumb
    }
  }
  searchDocuments {
    id
    language
  }
  myAssignment {
    id
    currentCourseInstance {
      id
    }
    currentModuleInstance {
      id
    }
  }
}
    `;
export const ChatReferences_AdminLibraryItemsDocument = gql`
    query ChatReferences_AdminLibraryItems($input: AdminLibraryInput!) {
  AdminLibrary(input: $input, pagination: {limit: 15, offset: 0}) {
    objects {
      ...LibraryItemForChatReference
    }
    totalCount
  }
}
    ${LibraryItemForChatReferenceFragmentDoc}`;

/**
 * __useChatReferences_AdminLibraryItemsQuery__
 *
 * To run a query within a React component, call `useChatReferences_AdminLibraryItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatReferences_AdminLibraryItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatReferences_AdminLibraryItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChatReferences_AdminLibraryItemsQuery(baseOptions: Apollo.QueryHookOptions<ChatReferences_AdminLibraryItemsQuery, ChatReferences_AdminLibraryItemsQueryVariables> & ({ variables: ChatReferences_AdminLibraryItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatReferences_AdminLibraryItemsQuery, ChatReferences_AdminLibraryItemsQueryVariables>(ChatReferences_AdminLibraryItemsDocument, options);
      }
export function useChatReferences_AdminLibraryItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatReferences_AdminLibraryItemsQuery, ChatReferences_AdminLibraryItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatReferences_AdminLibraryItemsQuery, ChatReferences_AdminLibraryItemsQueryVariables>(ChatReferences_AdminLibraryItemsDocument, options);
        }
export type ChatReferences_AdminLibraryItemsQueryHookResult = ReturnType<typeof useChatReferences_AdminLibraryItemsQuery>;
export type ChatReferences_AdminLibraryItemsLazyQueryHookResult = ReturnType<typeof useChatReferences_AdminLibraryItemsLazyQuery>;
export type ChatReferences_AdminLibraryItemsQueryResult = Apollo.QueryResult<ChatReferences_AdminLibraryItemsQuery, ChatReferences_AdminLibraryItemsQueryVariables>;
export const ChatReferences_TraineeLibraryItemsDocument = gql`
    query ChatReferences_TraineeLibraryItems($input: TraineeLibraryInput!) {
  TraineeLibrary(input: $input, pagination: {limit: 15, offset: 0}) {
    objects {
      ...LibraryItemForChatReference
    }
    totalCount
  }
}
    ${LibraryItemForChatReferenceFragmentDoc}`;

/**
 * __useChatReferences_TraineeLibraryItemsQuery__
 *
 * To run a query within a React component, call `useChatReferences_TraineeLibraryItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatReferences_TraineeLibraryItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatReferences_TraineeLibraryItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChatReferences_TraineeLibraryItemsQuery(baseOptions: Apollo.QueryHookOptions<ChatReferences_TraineeLibraryItemsQuery, ChatReferences_TraineeLibraryItemsQueryVariables> & ({ variables: ChatReferences_TraineeLibraryItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatReferences_TraineeLibraryItemsQuery, ChatReferences_TraineeLibraryItemsQueryVariables>(ChatReferences_TraineeLibraryItemsDocument, options);
      }
export function useChatReferences_TraineeLibraryItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatReferences_TraineeLibraryItemsQuery, ChatReferences_TraineeLibraryItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatReferences_TraineeLibraryItemsQuery, ChatReferences_TraineeLibraryItemsQueryVariables>(ChatReferences_TraineeLibraryItemsDocument, options);
        }
export type ChatReferences_TraineeLibraryItemsQueryHookResult = ReturnType<typeof useChatReferences_TraineeLibraryItemsQuery>;
export type ChatReferences_TraineeLibraryItemsLazyQueryHookResult = ReturnType<typeof useChatReferences_TraineeLibraryItemsLazyQuery>;
export type ChatReferences_TraineeLibraryItemsQueryResult = Apollo.QueryResult<ChatReferences_TraineeLibraryItemsQuery, ChatReferences_TraineeLibraryItemsQueryVariables>;
export const ChatReferences_LegacyAdminLibraryBySearchDocsDocument = gql`
    query ChatReferences_LegacyAdminLibraryBySearchDocs($input: AdminLibraryInput!) {
  AdminLibrary(input: $input, pagination: {limit: 15, offset: 0}) {
    objects {
      ...LibraryItemForChatReference
    }
    totalCount
  }
}
    ${LibraryItemForChatReferenceFragmentDoc}`;

/**
 * __useChatReferences_LegacyAdminLibraryBySearchDocsQuery__
 *
 * To run a query within a React component, call `useChatReferences_LegacyAdminLibraryBySearchDocsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatReferences_LegacyAdminLibraryBySearchDocsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatReferences_LegacyAdminLibraryBySearchDocsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChatReferences_LegacyAdminLibraryBySearchDocsQuery(baseOptions: Apollo.QueryHookOptions<ChatReferences_LegacyAdminLibraryBySearchDocsQuery, ChatReferences_LegacyAdminLibraryBySearchDocsQueryVariables> & ({ variables: ChatReferences_LegacyAdminLibraryBySearchDocsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatReferences_LegacyAdminLibraryBySearchDocsQuery, ChatReferences_LegacyAdminLibraryBySearchDocsQueryVariables>(ChatReferences_LegacyAdminLibraryBySearchDocsDocument, options);
      }
export function useChatReferences_LegacyAdminLibraryBySearchDocsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatReferences_LegacyAdminLibraryBySearchDocsQuery, ChatReferences_LegacyAdminLibraryBySearchDocsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatReferences_LegacyAdminLibraryBySearchDocsQuery, ChatReferences_LegacyAdminLibraryBySearchDocsQueryVariables>(ChatReferences_LegacyAdminLibraryBySearchDocsDocument, options);
        }
export type ChatReferences_LegacyAdminLibraryBySearchDocsQueryHookResult = ReturnType<typeof useChatReferences_LegacyAdminLibraryBySearchDocsQuery>;
export type ChatReferences_LegacyAdminLibraryBySearchDocsLazyQueryHookResult = ReturnType<typeof useChatReferences_LegacyAdminLibraryBySearchDocsLazyQuery>;
export type ChatReferences_LegacyAdminLibraryBySearchDocsQueryResult = Apollo.QueryResult<ChatReferences_LegacyAdminLibraryBySearchDocsQuery, ChatReferences_LegacyAdminLibraryBySearchDocsQueryVariables>;
export const ChatReferences_LegacyAssignmentsBySearchDocsDocument = gql`
    query ChatReferences_LegacyAssignmentsBySearchDocs($input: AssignmentsInput!) {
  Assignments(input: $input, pagination: {limit: 15, offset: 0}) {
    objects {
      id
      libraryItem {
        ...LibraryItemForChatReference
      }
    }
    totalCount
  }
}
    ${LibraryItemForChatReferenceFragmentDoc}`;

/**
 * __useChatReferences_LegacyAssignmentsBySearchDocsQuery__
 *
 * To run a query within a React component, call `useChatReferences_LegacyAssignmentsBySearchDocsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatReferences_LegacyAssignmentsBySearchDocsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatReferences_LegacyAssignmentsBySearchDocsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChatReferences_LegacyAssignmentsBySearchDocsQuery(baseOptions: Apollo.QueryHookOptions<ChatReferences_LegacyAssignmentsBySearchDocsQuery, ChatReferences_LegacyAssignmentsBySearchDocsQueryVariables> & ({ variables: ChatReferences_LegacyAssignmentsBySearchDocsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatReferences_LegacyAssignmentsBySearchDocsQuery, ChatReferences_LegacyAssignmentsBySearchDocsQueryVariables>(ChatReferences_LegacyAssignmentsBySearchDocsDocument, options);
      }
export function useChatReferences_LegacyAssignmentsBySearchDocsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatReferences_LegacyAssignmentsBySearchDocsQuery, ChatReferences_LegacyAssignmentsBySearchDocsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatReferences_LegacyAssignmentsBySearchDocsQuery, ChatReferences_LegacyAssignmentsBySearchDocsQueryVariables>(ChatReferences_LegacyAssignmentsBySearchDocsDocument, options);
        }
export type ChatReferences_LegacyAssignmentsBySearchDocsQueryHookResult = ReturnType<typeof useChatReferences_LegacyAssignmentsBySearchDocsQuery>;
export type ChatReferences_LegacyAssignmentsBySearchDocsLazyQueryHookResult = ReturnType<typeof useChatReferences_LegacyAssignmentsBySearchDocsLazyQuery>;
export type ChatReferences_LegacyAssignmentsBySearchDocsQueryResult = Apollo.QueryResult<ChatReferences_LegacyAssignmentsBySearchDocsQuery, ChatReferences_LegacyAssignmentsBySearchDocsQueryVariables>;